import { render, staticRenderFns } from "./soTab.vue?vue&type=template&id=3d9c48e7&scoped=true"
import script from "./soTab.vue?vue&type=script&lang=js"
export * from "./soTab.vue?vue&type=script&lang=js"
import style0 from "./soTab.vue?vue&type=style&index=0&id=3d9c48e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c48e7",
  null
  
)

export default component.exports